import EventCard from "components/Card/EventCard";
import { lang } from "constant/lang";
import React from "react";
import box1 from "images/pattern/box-1.svg";
import dotsBlueYellow1 from "images/pattern/dots-blue-yellow-1.svg";
import dotsBlueYellow2 from "images/pattern/dots-blue-yellow-2.svg";
import dotsBlueYellow3 from "images/pattern/dots-blue-yellow-3.svg";
import waveBlue from "images/pattern/wave-blue.svg";
import squareDouble from "images/pattern/square-double.svg";
import twirl3 from "images/pattern/twirl-3.svg";

const EventSection = () => {
  return (
    <div className="flex flex-col">
      <div
        className="inline-flex items-center bg-wce-yellow-light px-6 rounded-3xl
          font-yesevaOne text-wce-pink-bright text-2xl md:text-5xl h-12 md:h-20 w-fit mb-10 md:mb-16"
      >
        {lang.about.event.title}
      </div>
      <div className="absolute translate-y-full md:translate-y-0 bottom-10 md:bottom-0 left-0">
        <img className="w-[233px] min-w-[233px]" src={twirl3} alt={"twirl3"} />
      </div>
      <div className="relative flex flex-col gap-6 md:gap-10">
        <div className="absolute right-7 -top-2 translate-x-full hidden md:block">
          <img
            className="w-[95px] min-w-[95px]"
            src={dotsBlueYellow1}
            alt={"dotsBlueYellow1"}
          />
        </div>
        <div className="absolute left-3 top-[420px] -translate-x-full hidden md:block">
          <img
            className="w-[80px] min-w-[80px]"
            src={dotsBlueYellow2}
            alt={"dotsBlueYellow2"}
          />
        </div>
        <div className="relative">
          <div className="absolute -right-52 bottom-28 translate-x-full">
            <img className="w-[135px] min-w-[135px]" src={box1} alt={"box1"} />
          </div>
          <EventCard eventName={"mcc"} className={"w-full md:w-[60%]"} />
        </div>
        <div className="relative w-full md:w-[60%] self-end">
          <div className="absolute -left-[220px] bottom-4 -translate-x-full">
            <img
              className="w-[142px] min-w-[142px]"
              src={waveBlue}
              alt={"waveBlue"}
            />
          </div>
          <EventCard eventName={"companyVisit"} />
        </div>
        <div className="relative">
          <div className="absolute right-[400px] bottom-0 translate-x-full hidden md:block">
            <img
              className="w-[86px] min-w-[86px]"
              src={dotsBlueYellow3}
              alt={"dotsBlueYellow3"}
            />
          </div>
          <div className="absolute -right-24 top-0 hidden md:block">
            <img
              className="w-[172px] min-w-[172px]"
              src={squareDouble}
              alt={"squareDouble"}
            />
          </div>
          <EventCard className={"w-full md:w-[60%]"} eventName={"seminar"} />
        </div>
        <div className="relative w-full md:w-[60%] self-end">
          <EventCard eventName={"jobExpo"} />
        </div>
      </div>
    </div>
  );
};

export default EventSection;
